import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import Link from '@buyside/components/presentation/Link/link';

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusPendingPaladinApproval: React.FC = () => (
  <div className={styles.IdeaStatusPendingPaladinApproval}>
    <FontAwesomeIcon className={styles.faIcon} icon={faExclamationCircle} />
    Your idea is <strong>awaiting review</strong> by a member of SumZero's research quality team.
    Once it has been approved, your idea will be published on the SumZero Research Database. Please
    contact <Link to="mailto:support@sumzero.com">support@sumzero.com</Link> with any questions.
  </div>
);

export default IdeaStatusPendingPaladinApproval;
